<template>
  <div>
    <el-collapse>
      <el-collapse-item
        v-for="(risk, riskLevel) in workflow.risks"
        v-bind:key="riskLevel"
        :title="`${$t('Riesgos Nivel')} ${risk[0].riskLevel}`">
        <el-row>
          <el-col :span="4">
            <el-steps :space="100" direction="vertical" :active="risk.length">
              <el-step
                v-for="step_index in risk.length"
                v-bind:key="step_index"
                :title="`${$t('Paso')} (${step_index})`">
              </el-step>
            </el-steps>
          </el-col>
          <el-col :span="20">
            <div
              v-for="(step, step_index) in risk"
              v-bind:key="step_index">
              <el-col :span="24">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span style="line-height: 36px;">
                      <b>
                        {{$t('Paso')}} {{ step_index + 1 }} - {{$t('Aprobación')}}
                        ({{ step.minToApprove }}/{{ step.totalPeople }})
                      </b>
                    </span>
                  </div>
                  <div v-if="params.description_only">
                    <div
                      v-for="(profile, index) in step.peopleProfile"
                      v-bind:key="index"
                      class="people-container">
                      <div class="person">
                        <p>
                          <b>{{$t('Revisor')}} {{ index + 1 }}:</b>
                          {{ bhpProfiles[profile] }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <el-table
                    :data="step.people">
                    <el-table-column
                      prop="name"
                      :label="$t('Nombre')">
                    </el-table-column>
                    <el-table-column
                      prop="email"
                      :label="$t('Correo')">
                    </el-table-column>
                    <el-table-column
                      prop="description"
                      :label="$t('Descripción')">
                    </el-table-column>
                  </el-table>
                  </div>
                </el-card>
              </el-col>
            </div>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'workflow',
  props: ['workflow', 'params'],
  data() {
    return {
      bhpProfiles: {
        hse: 'Asesor SSO',
        health: this.$t('Especialista de Salud'),
        safety: this.$t('Especialista de Seguridad'),
        environment: this.$t('Especialista de Medioambiente'),
        contractor_hse: this.$t('Asesor SSO Contratista'),
        owner: this.$t('Dueño de Contrato'),
        contract_owner: this.$t('Dueño de Contrato'),
        risk: this.$t('Especialista de Riesgo'),
        administrator: this.$t('Administrador de Contrato'),
        contractor_coordinator: this.$t('Coordinador Contratista'),
        coordinator: this.$t('Coordinador'),
        manager: this.$t('Gerente de Área'),
        super: this.$t('Superintendente de Área'),
        general_manager: this.$t('Gerente General'),
      },
    };
  },
};
</script>
